export default __webpack_public_path__ + "static/media/waving-hand-1x.8299ca8a.png";